import i18n from "i18next";
import React from "react";
import { useTranslation } from "react-i18next";

import SlideTransition from "../../components/SlideTransition";

import { useInView } from "../../hooks/useInView";
import { content } from "../../utils/content";

const AboutPage = () => {
  const [setRef, visible] = useInView({
    threshold: 0.1,
  });

  const { t } = useTranslation();

  return (
    <div
      className="flex flex-col items-center justify-start min-h-[70vh] relative w-full"
      ref={setRef}
    >
      <div className="flex flex-col items-center justify-center max-w-screen-xl px-3 py-4 space-y-8 w-full xl:px-0 xl:py-12 xl:space-y-12">
        <div className="flex flex-col justify-start space-y-2 w-full">
          <SlideTransition appear={visible} timeout={400}>
            <h1 className="capitalize font-bold leading-snug text-4xl  text-secondary tracking-wide sm:leading-normal sm:text-6xl sm:text-center">
              {t(content.about.subheader)}
            </h1>
          </SlideTransition>

          <SlideTransition appear={visible} timeout={400}>
            <p className="font-normal leading-normal px-1 text-gray-600 text-sm tracking-wide sm:text-base sm:text-center">
              {t(content.about.content)}
            </p>
          </SlideTransition>
        </div>

        <SlideTransition appear={visible} className="w-full" timeout={600}>
          <div
            className="!bg-cover bg-gray-100 !bg-center !bg-no-repeat h-[100px] sm:h-[300px] w-full"
            style={{
              background: `url(${
                i18n.language === "en"
                  ? content.about.image.en
                  : content.about.image.cn
              })`,
            }}
          />
        </SlideTransition>

        <SlideTransition appear={visible} timeout={800}>
          <p className="font-bold text-center tracking-wider sm:text-lg">
            {t(content.about.itemHeader)}
          </p>
        </SlideTransition>

        <SlideTransition appear={visible} timeout={800}>
          <div className="flex flex-wrap">
            {content.about?.items.map((item, index) => (
              <div
                className="flex items-center px-2 py-5 space-x-3 w-full sm:px-6 sm:py-6 sm:w-1/2 lg:w-1/3"
                key={index}
              >
                <div className="bg-secondary flex h-[30px] items-center justify-center min-w-[30px] text-white rounded-full sm:h-[36px] sm:min-w-[36px]">
                  {String(index + 1).padStart(2, "0")}
                </div>

                <p className="text-gray-600 text-sm sm:text-base">{t(item)}</p>
              </div>
            ))}
          </div>
        </SlideTransition>
      </div>
    </div>
  );
};

export default AboutPage;
